export default {
  FEDEX: 'FEDEX',
  DHL: 'DHL',
  ESTAFETA: 'ESTAFETA',
};
